import { Badge } from 'antd'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { t } from 'i18next'
import GlobalContext from '../GlobalContext'
import { Color } from '../../Common/Color'

export default function ChatBadge () {
  const { openChats } = useContext(GlobalContext)

  return (
    <Badge count={openChats.filter(chat => chat.open).length} style={{ '--ant-color-text': Color.primary }}>
      <Link to={'/admin/chats'} style={{ fontSize: '24px' }}>
        {t('Admin.Menu.chats')}
      </Link>
    </Badge>
  )
}
